module.exports = __webpack_public_path__ + "img/01_white_talk.21c0e7f4.gif";